<template>
  <div class="work-complete">
    <div class="header">
      <div class="select">
        <mk-select
          v-model="signInIndex"
          class="select-item"
          width="120"
          placeholder="签到状态"
          clearable
        >
          <mk-option
            v-for="(item,index) in signInOptions"
            :key="index"
            :label="item.label"
            :value="item.value"
          >
          </mk-option>
        </mk-select>
        <mk-select
          v-model="taskIndex"
          class="select-item"
          width="140"
          placeholder="任务完成情况"
          clearable
        >
          <mk-option
            v-for="(item,index) in taskOptions"
            :key="index"
            :label="item.label"
            :value="item.value"
          >
          </mk-option>
        </mk-select>
        <mk-select
          v-model="journalIndex"
          class="select-item"
          width="140"
          placeholder="日志提交情况"
          clearable
        >
          <mk-option
            v-for="(item,index) in journalOptions"
            :key="index"
            :label="item.label"
            :value="item.value"
          >
          </mk-option>
        </mk-select>
        <mk-date-picker
          v-model="date"
          class="select-item"
          value-format="yyyy-MM-dd"
          format="yyyy-MM-dd"
          type="date"
          placeholder="选择日期"
        />
        <mk-select
          v-model="title"
          class="select-item"
          filterable
          clearable
          remote
          :remote-method="querySearchAsync"
          placeholder="搜索姓名"
          width="150"
          :loading="isFetchData"
        >
          <mk-option
            v-for="item in nameOptions"
            :key="item._id"
            :label="item.name"
            :value="item._id"
          >
          </mk-option>
        </mk-select>
        <div class="btn-group">
          <mk-button-biz
            class="search-btn"
            icon="el-icon-search"
            type="primary"
            @click="search"
          >
            搜索
          </mk-button-biz>
          <mk-button-biz
            width="64px"
            class="reset-btn"
            @click="reset"
          >
            重置
          </mk-button-biz>
        </div>
      </div>
      <div>
        <mk-button-biz
          class="export-btn"
          type="primary"
          :loading="loading"
          @click="exportXls"
        >
          导出
        </mk-button-biz>
        <mk-button-biz
          class="export-btn"
          type="primary"
          @click="groupAttention"
        >
          群发提醒
        </mk-button-biz>
      </div>
    </div>
    <div class="sale-info">
      <p>{{ saleInfo.day }}</p>
      <p>完成签到人数：{{ saleInfo.signTotal }}/<span>{{ saleInfo.verifyTotal }}</span></p>
      <p>完成任务人数：{{ saleInfo.taskFinishedTotal }}/<span>{{ saleInfo.verifyTotal }}</span></p>
      <p>提交日志人数：{{ saleInfo.submitTotal }}/<span>{{ saleInfo.verifyTotal }}</span></p>
    </div>
    <div class="content">
      <mk-table
        :data="list"
        height="100%"
      >
        <mk-table-column
          label="头像"
          width="50"
        >
          <template v-slot="scope">
            <img
              v-if="scope.row.sale[0].avatarUrl"
              class="avatarUrl"
              :src="scope.row.sale[0].avatarUrl"
            >
            <img
              v-else
              class="avatarUrl"
              src="@/assets/images/user.png"
            >
          </template>
        </mk-table-column>
        <mk-table-column
          label="姓名"
          min-width="120"
        >
          <template v-slot="scope">
            <span v-if="scope.row.sale[0].name">{{ scope.row.sale[0].name }}</span>
          </template>
        </mk-table-column>
        <mk-table-column
          label="签到情况"
          min-width="80"
        >
          <template v-slot="scope">
            <span>{{ scope.row.isSign ? '已签到' : '未签到' }}</span>
          </template>
        </mk-table-column>
        <mk-table-column
          label="任务完成情况"
          min-width="120"
        >
          <template v-slot="scope">
            <div class="task-complete">
              <template v-if="scope.row.totalTaskFinished">
                <div>
                  {{ scope.row.totalTaskFinished >=scope.row.taskTotal ? '已完成': '未完成' }}
                  <mk-tooltip
                    class="item"
                    effect="light"
                    content="点击查看任务截图"
                    placement="right"
                  >
                    <span
                      class="finish-screen"
                      @click="preview(scope.row)"
                    >
                      （{{ scope.row.totalTaskFinished }}/{{ scope.row.taskTotal }}）
                    </span>
                  </mk-tooltip>
                </div>
              </template>
              <template v-else>
                未完成（{{ scope.row.totalTaskFinished }}/{{ scope.row.taskTotal }}）
              </template>
            </div>
          </template>
        </mk-table-column>
        <mk-table-column
          label="日志提交情况"
          min-width="120"
        >
          <template v-slot="scope">
            {{ scope.row.isSubmitLog ? '已提交' : '未提交' }}
          </template>
        </mk-table-column>
        <mk-table-column
          label="日期"
          prop="day"
          min-width="120"
        />
        <mk-table-column
          label="操作"
          width="80"
          fixed="right"
        >
          <template v-slot="scope">
            <mk-button-biz
              type="text"
              @click="handleDetail(scope.row)"
            >
              详情
            </mk-button-biz>
          </template>
        </mk-table-column>
      </mk-table>
    </div>
    <div class="handle-page">
      <!-- <div class="total-info">
        共{{ total }}条
      </div> -->
      <div class="page-info">
        <mk-pagination
          class="pagination"
          :current-page.sync="page"
          :page-size="10"
          layout="total, prev, pager, next, jumper"
          :total="total"
          @current-change="handleCurrentChange"
        >
        </mk-pagination>
        <!-- <span class="page-tip">10条/页</span>
        <div class="jump">
          跳至
          <input
            v-model="nowPage"
            type="number"
            @keyup.enter="updatePage"
          />
          页
        </div> -->
      </div>
    </div>
    <group-attention
      v-if="showGroup"
      :show="showGroup"
      init-total="total"
      @cancel="cancel"
    ></group-attention>
    <sale-detail
      v-if="show"
      :show="show"
      :user-info="userInfo"
      @cancel="cancel"
    ></sale-detail>
    <screenshot
      v-if="showScreen"
      :show="showScreen"
      :list="screenshotList"
      @cancel="cancel"
    ></screenshot>
  </div>
</template>
<script>
import saleDetail from '../../statistical-performance/components/sale-detail.vue'
import groupAttention from '../../components/group-attention.vue'
import screenshot from '../../components/task-screenshot.vue'
import { BIZAPIS } from '../../../../api'
export default {
  components: {
    saleDetail,
    groupAttention,
    screenshot
  },
  data () {
    return {
      title: '',
      signInIndex: '',
      signInOptions: [
        {
          label: '未签到',
          value: 0
        },
        {
          label: '已签到',
          value: 1
        }
      ],
      taskIndex: '',
      taskOptions: [
        {
          label: '未完成',
          value: 0
        },
        {
          label: '已完成',
          value: 1
        }
      ],
      journalIndex: '',
      journalOptions: [
        {
          label: '未提交',
          value: 0
        },
        {
          label: '已提交',
          value: 1
        }
      ],
      date: '',
      list: [],
      page: 1,
      nowPage: 1,
      total: 0,
      saleInfo: {
        day: '',
        signTotal: 0,
        submitTotal: 0,
        taskFinishedTotal: 0,
        verifyTotal: 0
      },
      allSaleNumber: 0,
      showGroup: false,
      userInfo: {},
      show: false,
      nameOptions: [],
      isFetchData: false,
      loading: false,
      showScreen: false, // 是否展示任务截图
      screenshotList: [] // 任务截图列表
    }
  },
  watch: {},
  created () {
    this.getList()
    this.getStatist()
  },
  methods: {
    preview (data) {
      // 预览任务截图
      this.showScreen = true
      this.screenshotList = data.taskFinished
    },
    async exportXls () {
      this.loading = true
      const metas = {}
      if (this.signInIndex === 0) {
        metas['isSign'] = false
      } else if (this.signInIndex === 1) {
        metas['isSign'] = true
      } else {
        delete metas['isSign']
      }
      if (this.taskIndex === 0) {
        metas['isTaskFinished'] = false
      } else if (this.taskIndex === 1) {
        metas['isTaskFinished'] = true
      } else {
        delete metas['isTaskFinished']
      }
      if (this.journalIndex === 0) {
        metas['isSubmitLog'] = false
      } else if (this.journalIndex === 1) {
        metas['isSubmitLog'] = true
      } else {
        delete metas['isSubmitLog']
      }
      if (this.date) {
        metas['day'] = this.date
      } else {
        delete metas['day']
      }
      if (this.title) {
        metas['saleID'] = this.title
      } else {
        delete metas['saleId']
      }
      const res = await BIZAPIS.ExportApi.exportYqfWorkStatisticsGet(metas)
      if (res.success) {
        this.util.download({
          href: res.data
        })
        this.loading = false
      } else {
        this.loading = false
        this.$message({
          type: 'error',
          message: res.msg,
          showClose: true
        })
      }
    },
    async querySearchAsync (str) {
      if (str) {
        this.isFetchData = true
        // const res = await BIZAPIS.SalesApi.yqfSalesManageListPost({
        //   page: 1,
        //   name: str
        // })
        const res = await BIZAPIS.SalesApi.yqfSalesManageMatchGet({
          name: str
        })
        if (res.success) {
          this.isFetchData = false
          this.nameOptions = res.data.data
        }
      } else {
        this.isFetchData = false
        this.nameOptions = []
      }
    },
    handleDetail (data) {
      this.show = true
      this.userInfo = {
        userId: data.sale[0]._id,
        ...data.sale[0]
      }
    },
    groupAttention () {
      this.showGroup = true
    },
    cancel () {
      this.showGroup = false
      this.show = false
      this.showScreen = false
    },
    search () {
      this.page = 1
      this.nowPage = 1
      this.getList()
      this.getStatist()
    },
    reset () {
      this.signInIndex = ''
      this.taskIndex = ''
      this.journalIndex = ''
      this.date = ''
      this.title = ''
    },
    updatePage (e) {
      if (Number(this.nowPage) < 1) {
        this.nowPage = 1
        this.page = 1
      } else {
        if (Math.ceil(this.total / 10) <= Number(this.nowPage)) {
          this.nowPage = Math.ceil(this.total / 10)
        }
      }
      this.page = Number(this.nowPage)
      this.getList()
    },
    handleCurrentChange (e) {
      this.nowPage = e
      this.page = e
      this.getList()
    },
    async getList () {
      let metas = {
        page: this.page,
        pageSize: 10
      }

      if (this.signInIndex === 0) {
        metas['isSign'] = false
      } else if (this.signInIndex === 1) {
        metas['isSign'] = true
      } else {
        delete metas['isSign']
      } // isTaskFinished
      // taskIndex
      if (this.taskIndex === 0) {
        metas['isTaskFinished'] = false
      } else if (this.taskIndex === 1) {
        metas['isTaskFinished'] = true
      } else {
        delete metas['isTaskFinished']
      }
      if (this.journalIndex === 0) {
        metas['isSubmitLog'] = false
      } else if (this.journalIndex === 1) {
        metas['isSubmitLog'] = true
      } else {
        delete metas['isSubmitLog']
      }
      if (this.date) {
        metas['day'] = this.date
      } else {
        delete metas['day']
      }
      if (this.title) {
        metas['saleID'] = this.title
      } else {
        delete metas['saleId']
      }
      const res = await BIZAPIS.YqfworkstatisticsApi.yqfWorkStatisticsGet(metas)
      if (res.success) {
        this.list = res.data.data
        this.total = res.data.total
      }
    },
    async getStatist () {
      let metas = {}
      if (this.date) {
        metas['day'] = this.date
      } else {
        delete metas['day']
      }
      const res = await BIZAPIS.YqfworkstatisticsApi.yqfWorkStatisticsOverviewGet(
        metas
      )
      if (res.success) {
        this.saleInfo = res.data
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.work-complete {
  display: flex;
  flex-direction: column;
  height: 100%;
  // min-width: 1180px;

  .header {
    width: calc(100% - 40px);
    margin: 0 auto;
    margin-top: 20px;
    flex-shrink: 0;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .select {
      display: flex;

      .select-item {
        margin-right: 10px;
      }

      /deep/ .search-btn {
        padding: 0 14px !important;
        border-radius: 4px;

        .el-icon-search {
          font-size: 14px;
        }

        span {
          font-size: 13px;
          margin-left: 4px;
        }
      }

      /deep/ .reset-btn {
        span {
          font-size: 13px;
        }
      }
    }

    .new-add-btn {
      margin-right: 10px;
    }

    /deep/ .new-add-btn {
      padding: 0 8px !important;
    }

    /deep/ .export-btn {
      padding: 0 11px !important;
    }
  }

  .sale-info {
    width: calc(100% - 40px);
    margin: 0 auto;
    font-size: 13px;
    padding: 24px 0 16px 0;
    display: flex;

    p {
      margin-right: 32px;

      span {
        color: #888;
      }
    }
  }

  .content {
    width: calc(100% - 40px);
    margin: 0 auto;
    height: 100%;
    overflow: auto;

    .finish-screen {
      cursor: pointer;
      color: #009cff;
    }

    .avatarUrl {
      display: block;
      width: 26px;
      height: 26px;
      border-radius: 2px;
    }
  }

  .handle-page {
    width: calc(100% - 40px);
    margin: 0 auto;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    padding: 24px 0 28px 0;

    .total-info {
      font-size: 13px;
      color: #6d7278;
      margin-left: 10px;
    }

    .page-info {
      display: flex;
      align-items: center;
      justify-content: flex-end;

      // /deep/ .pagination {
      //   font-size: 13px;
      //   display: flex;
      //   align-items: center;
      //   margin-top: 0;

      //   .btn-prev {
      //     background: none;
      //     width: 0;
      //     height: 0;
      //     border-top: 6px solid transparent;
      //     border-bottom: 6px solid transparent;
      //     border-right: 6px solid #595959;

      //     .el-icon-arrow-left {
      //       display: none;
      //     }
      //   }

      //   .btn-prev:disabled {
      //     border-right: 6px solid #bfbfbf;
      //   }

      //   .btn-next {
      //     background: none;
      //     width: 0;
      //     height: 0;
      //     border-top: 6px solid transparent;
      //     border-bottom: 6px solid transparent;
      //     border-left: 6px solid #595959;

      //     .el-icon-arrow-right {
      //       display: none;
      //     }
      //   }

      //   .btn-next:disabled {
      //     border-left: 6px solid #bfbfbf;
      //   }

      //   .el-pager {
      //     margin: 0 8px;

      //     li {
      //       min-width: 30px;
      //       height: 24px;
      //       line-height: 24px;
      //     }
      //   }
      // }

      .page-tip {
        font-size: 14px;
        color: #595959;
        margin-left: -16px;
      }

      .jump {
        font-size: 13px;
        color: #595959;
        margin-left: 88px;

        input {
          width: 58px;
          height: 24px;
          padding: 0 12px;
          box-sizing: border-box;
          border: 1px solid #d9d9d9;
          border-radius: 2px;
        }

        input::-webkit-outer-spin-button,
        input::-webkit-inner-spin-button {
          -webkit-appearance: none;
        }

        input[type='number'] {
          -moz-appearance: textfield;
        }
      }
    }
  }
}
</style>
